(function () {
  var root = document.documentElement;
  var KEY = 'ab-theme';
  var systemDark = window.matchMedia('(prefers-color-scheme: dark)');

  function saved() {
    try { return localStorage.getItem(KEY); } catch (e) { return null; }
  }

  function apply(mode) {
    root.setAttribute('data-theme', mode);
    document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-label', mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
    });
  }

  apply(root.getAttribute('data-theme') || (systemDark.matches ? 'dark' : 'light'));

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-theme-toggle]');
    if (!btn) return;
    var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    // Picking the mode the system already uses goes back to following the system.
    try {
      if ((next === 'dark') === systemDark.matches) localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, next);
    } catch (err) {}
    apply(next);
    btn.classList.remove('is-switching');
    void btn.offsetWidth;
    btn.classList.add('is-switching');
  });

  var onSystemChange = function (e) {
    if (!saved()) apply(e.matches ? 'dark' : 'light');
  };
  if (systemDark.addEventListener) systemDark.addEventListener('change', onSystemChange);
  else if (systemDark.addListener) systemDark.addListener(onSystemChange);

  /* The page-links bar sits under the header while the header is showing
     and moves to the top when the header slides away. */
  var header = document.querySelector('.header');
  var subnav = document.querySelector('[data-ab-subnav]');
  if (header && subnav) {
    var sync = function () {
      var hidden = header.classList.contains('header--hidden');
      root.style.setProperty('--ab-header-offset', hidden ? '0px' : header.offsetHeight + 'px');
    };
    sync();
    new MutationObserver(sync).observe(header, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', sync);

    var links = Array.prototype.slice.call(subnav.querySelectorAll('a[href^="#"]'));
    var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (a, i) { a.classList.toggle('is-active', targets[i] === entry.target); });
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      targets.forEach(function (t) { if (t) io.observe(t); });
    }
  }

  /* Product gallery: thumbnails swap the main image, the zoom button opens it large. */
  document.querySelectorAll('[data-ab-pdp]').forEach(function (pdp) {
    var mainImg = pdp.querySelector('.ab-pdp__main img');
    var dialog = pdp.querySelector('[data-ab-zoom-dialog]');
    var zoomImg = dialog && dialog.querySelector('[data-ab-zoom-img]');
    var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('[data-ab-thumb]'));
    var count = pdp.querySelector('[data-ab-count]');
    var current = 0;

    function go(i) {
      if (!mainImg || !thumbs.length) return;
      current = (i + thumbs.length) % thumbs.length;
      var thumb = thumbs[current];
      mainImg.removeAttribute('srcset');
      mainImg.src = thumb.getAttribute('data-full');
      mainImg.alt = thumb.getAttribute('data-alt') || '';
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      if (count) count.textContent = (current + 1) + ' / ' + thumbs.length;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { go(i); });
    });
    pdp.querySelectorAll('[data-ab-step]').forEach(function (btn) {
      if (thumbs.length < 2) { btn.hidden = true; return; }
      btn.addEventListener('click', function () { go(current + parseInt(btn.getAttribute('data-ab-step'), 10)); });
    });
    if (count && thumbs.length > 1) count.textContent = '1 / ' + thumbs.length;

    var stage = pdp.querySelector('.ab-pdp__main');
    var startX = null;
    if (stage && thumbs.length > 1) {
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1));
      });
    }

    var zoomBtn = pdp.querySelector('[data-ab-zoom]');
    if (zoomBtn && dialog && zoomImg && dialog.showModal) {
      zoomBtn.addEventListener('click', function () {
        var active = pdp.querySelector('[data-ab-thumb].is-active');
        zoomImg.src = active ? active.getAttribute('data-full') : mainImg.currentSrc || mainImg.src;
        zoomImg.alt = mainImg.alt;
        dialog.showModal();
      });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('[data-ab-zoom-close]')) dialog.close();
      });
    }
  });

  /* Floating add-to-bag: shows once the main button has scrolled away, and
     steps aside while another buy button or the footer is on screen. */
  (function () {
    var bar = document.querySelector('[data-ab-sticky]');
    var main = document.querySelector('.ab-pdp__form');
    if (!bar || !main) return;
    var phone = window.matchMedia('(max-width: 899px)');
    var button = bar.querySelector('button');
    var rivals = Array.prototype.filter.call(
      document.querySelectorAll('form[data-product-form]'),
      function (f) { return f !== main && !bar.contains(f) && !f.closest('[data-ab-subnav]'); }
    );
    var footer = document.querySelector('.ab-footer, footer');
    var mainSelect = main.querySelector('select[name="id"]');
    var stickyId = bar.querySelector('input[name="id"]');
    if (mainSelect && stickyId) {
      mainSelect.addEventListener('change', function () { stickyId.value = mainSelect.value; });
    }

    function onScreen(el) {
      if (!el.offsetParent && getComputedStyle(el).position !== 'fixed') return false;
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }

    var queued = false;
    function update() {
      queued = false;
      var show = main.getBoundingClientRect().bottom < 0;
      if (show && footer && onScreen(footer)) show = false;
      for (var i = 0; show && i < rivals.length; i++) {
        if (onScreen(rivals[i])) show = false;
      }
      // Shopify's preview bar (shown to staff) renders in the top layer at the
      // bottom of the screen, so the bar has to sit above it to be seen at all.
      var pbar = document.getElementById('PBarNextFrameWrapper');
      var lift = 0;
      if (pbar) {
        var pr = pbar.getBoundingClientRect();
        if (pr.height && pr.top < window.innerHeight) lift = Math.round(window.innerHeight - pr.top);
      }
      bar.style.bottom = lift ? lift + (phone.matches ? 0 : 24) + 'px' : '';
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      root.classList.toggle('ab-sticky-on', show);
      if (button) button.tabIndex = show ? 0 : -1;
      root.style.setProperty('--sticky-buy-offset', show && phone.matches ? bar.offsetHeight + 8 + lift + 'px' : '0px');
    }
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  })();

  /* Product list: sort and filter in place. */
  document.querySelectorAll('[data-ab-cat]').forEach(function (cat) {
    var grid = cat.querySelector('[data-ab-grid]');
    var items = Array.prototype.slice.call(cat.querySelectorAll('[data-ab-item]'));
    var sort = cat.querySelector('[data-ab-sort]');
    var stock = cat.querySelector('[data-ab-f-stock]');
    var typeBoxes = Array.prototype.slice.call(cat.querySelectorAll('[data-ab-f-type]'));
    var label = cat.querySelector('[data-ab-count-label]');
    var empty = cat.querySelector('[data-ab-empty]');
    var filter = cat.querySelector('[data-ab-filter]');

    function apply() {
      var types = typeBoxes.filter(function (b) { return b.checked; }).map(function (b) { return b.value; });
      var shown = 0;
      items.forEach(function (el) {
        var ok = (!stock || !stock.checked || el.getAttribute('data-available') === 'true') &&
          (!types.length || types.indexOf(el.getAttribute('data-type')) > -1);
        el.hidden = !ok;
        if (ok) shown++;
      });
      var mode = sort ? sort.value : 'featured';
      items.slice().sort(function (a, b) {
        var pa = +a.getAttribute('data-price'), pb = +b.getAttribute('data-price');
        var ta = a.getAttribute('data-title'), tb = b.getAttribute('data-title');
        if (mode === 'price-asc') return pa - pb;
        if (mode === 'price-desc') return pb - pa;
        if (mode === 'az') return ta.localeCompare(tb);
        if (mode === 'za') return tb.localeCompare(ta);
        return a.getAttribute('data-index') - b.getAttribute('data-index');
      }).forEach(function (el) { grid.appendChild(el); });
      if (label) label.textContent = shown + (shown === 1 ? ' product' : ' products');
      if (empty) empty.hidden = shown > 0;
    }

    if (sort) sort.addEventListener('change', apply);
    cat.addEventListener('change', function (e) {
      if (e.target.matches('[data-ab-f-stock], [data-ab-f-type]')) apply();
    });
    var clear = cat.querySelector('[data-ab-f-clear]');
    if (clear) clear.addEventListener('click', function () {
      if (stock) stock.checked = false;
      typeBoxes.forEach(function (b) { b.checked = false; });
      apply();
    });
    document.addEventListener('click', function (e) {
      if (filter && filter.open && !filter.contains(e.target)) filter.open = false;
    });
  });

  /* Announcement bar: rotates messages, arrows step through them. */
  document.querySelectorAll('[data-ab-announce]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('.ab-announce__msg');
    if (msgs.length < 2) return;
    var current = 0;
    var delay = (parseInt(bar.getAttribute('data-interval'), 10) || 5) * 1000;
    var timer = null;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(i) {
      current = (i + msgs.length) % msgs.length;
      msgs.forEach(function (m, n) { m.classList.toggle('is-active', n === current); });
    }
    function start() {
      clearInterval(timer);
      if (!still) timer = setInterval(function () { show(current + 1); }, delay);
    }
    bar.querySelectorAll('[data-ab-announce-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        show(current + parseInt(btn.getAttribute('data-ab-announce-step'), 10));
        start();
      });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearInterval(timer); else start();
    });
    start();
  });

  /* Hero slideshow. */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-ab-slides]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.ab-slide');
    var dots = hero.querySelectorAll('[data-ab-slide-dot]');
    if (slides.length < 2) return;
    var current = 0;
    var delay = (parseInt(hero.getAttribute('data-interval'), 10) || 5) * 1000;
    var timer = null;
    var userPicked = false;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === current); });
    }
    function start() {
      if (reduceMotion || userPicked) return;
      clearInterval(timer);
      timer = setInterval(function () { show(current + 1); }, delay);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        userPicked = true;
        clearInterval(timer);
        show(parseInt(dot.getAttribute('data-ab-slide-dot'), 10));
      });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearInterval(timer);
      else start();
    });
    start();
  });

  /* Split image slideshow: arrows step through, swipe on touch. */
  document.querySelectorAll('[data-ab-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('[data-ab-gallery-slide]');
    var count = gallery.querySelector('[data-ab-gallery-count]');
    var current = 0;
    function go(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === current);
        if (n === current) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
      if (count) count.textContent = (current + 1) + ' / ' + slides.length;
    }
    gallery.querySelectorAll('[data-ab-gallery-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        go(current + parseInt(btn.getAttribute('data-ab-gallery-step'), 10));
      });
    });
    var startX = null;
    gallery.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1));
      startX = null;
    });
  });

  /* Header search: on desktop the icon opens the inline bar instead of the search page. */
  document.querySelectorAll('.ab-search').forEach(function (wrap) {
    var open = wrap.querySelector('[data-ab-search-open]');
    var form = wrap.querySelector('.ab-search-peek');
    var input = wrap.querySelector('.ab-search-peek__input');
    if (!open || !form || !input) return;
    open.addEventListener('click', function (e) {
      if (getComputedStyle(form).display === 'none') return;
      e.preventDefault();
      if (input.value.trim()) return form.submit();
      wrap.classList.add('is-open');
      input.focus();
    });
    wrap.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!wrap.contains(document.activeElement)) wrap.classList.remove('is-open');
      }, 0);
    });
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); }
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { input.value = ''; input.blur(); }
    });
  });

  /* Logo: one light sweep on the first page of a visit. */
  var logo = document.querySelector('.header__logo');
  if (logo && !reduceMotion) {
    try {
      if (!sessionStorage.getItem('ab-logo-shine')) {
        sessionStorage.setItem('ab-logo-shine', '1');
        logo.classList.add('is-shine');
        logo.addEventListener('animationend', function () { logo.classList.remove('is-shine'); }, { once: true });
      }
    } catch (e) {}
  }

  /* Big-number sections: a soft glow trails the cursor. */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.ab-number').forEach(function (section) {
      var x = 0, y = 0, tx = 0, ty = 0, frame = null;
      function step() {
        x += (tx - x) * (reduceMotion ? 1 : 0.12);
        y += (ty - y) * (reduceMotion ? 1 : 0.12);
        section.style.setProperty('--glow-x', x + 'px');
        section.style.setProperty('--glow-y', y + 'px');
        frame = Math.abs(tx - x) + Math.abs(ty - y) > 0.5 ? requestAnimationFrame(step) : null;
      }
      section.addEventListener('pointerenter', function (e) {
        var r = section.getBoundingClientRect();
        x = tx = e.clientX - r.left;
        y = ty = e.clientY - r.top;
        step();
        section.classList.add('is-glowing');
      });
      section.addEventListener('pointermove', function (e) {
        var r = section.getBoundingClientRect();
        tx = e.clientX - r.left;
        ty = e.clientY - r.top;
        if (!frame) frame = requestAnimationFrame(step);
      });
      section.addEventListener('pointerleave', function () {
        section.classList.remove('is-glowing');
      });
    });
  }
})();

/* Subscription options (Shopify Subscriptions app). The app only knows how to
   update prices in Debut/Brooklyn markup, so the price on each option, the
   main price and the add-to-bag label are handled here. */
(function () {
  var slot = document.querySelector('.ab-pdp__form .subscriptions_app_embed_block');
  if (!slot) return;
  var priceEl = document.querySelector('[data-ab-price]');
  var btn = slot.closest('form').querySelector('.ab-pdp__add');
  var basePrice = priceEl ? priceEl.innerHTML : '';
  var baseBtn = btn ? btn.textContent : '';

  function read(script) {
    try { return script ? JSON.parse(script.textContent) : null; } catch (e) { return null; }
  }
  function short(s) { return s.replace(/\s+[A-Z]{3}$/, ''); }
  function amount(s) { return parseFloat(s.replace(/[^0-9.]/g, '')) || 0; }

  function setup() {
    var block = slot.querySelector('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)');
    if (!block || block.hasAttribute('data-ab-ready')) return;
    block.setAttribute('data-ab-ready', '');

    block.querySelectorAll('.shopify_subscriptions_app_block_label').forEach(function (opt) {
      var label = opt.querySelector(':scope > label');
      var input = label && label.querySelector('input');
      if (!input) return;
      var data = input.dataset.radioType === 'one_time_purchase'
        ? read(document.getElementById('subscriptions_money_with_currency_one_time_purchase_' + input.dataset.variantId))
        : read(opt.querySelector('script[type="application/json"]'));
      if (!data || !data.price) return;
      opt._abPrice = data;

      var was = data.comparedAtPrice && data.comparedAtPrice !== data.price ? data.comparedAtPrice : '';
      var price = document.createElement('span');
      price.className = 'ab-sub__price';
      price.innerHTML = short(data.price) + (was ? '<s>' + short(was) + '</s>' : '');
      label.appendChild(price);

      var saved = was ? amount(was) - amount(data.price) : 0;
      if (saved > 0) {
        var tag = document.createElement('span');
        tag.className = 'ab-sub__save';
        tag.textContent = 'Save $' + (saved % 1 ? saved.toFixed(2) : saved);
        opt.appendChild(tag);
      }
    });

    var plans = block.querySelectorAll('[data-radio-type="selling_plan"]');
    var policy = block.querySelector('.shopify_subscriptions_app_policy');
    if (plans.length === 1 && policy) {
      var freq = plans[0].closest('label').textContent.trim().replace(/,[^,]*off$/i, '');
      if (freq) policy.textContent = freq + ' · ' + policy.textContent.trim();
    }
    update();
  }

  function update() {
    var checked = slot.querySelector('.shopify_subscriptions_app_block_label > label input:checked');
    var data = checked && checked.closest('.shopify_subscriptions_app_block_label')._abPrice;
    var sub = data && checked.dataset.radioType !== 'one_time_purchase';
    if (priceEl) {
      priceEl.innerHTML = sub
        ? data.price + (data.comparedAtPrice && data.comparedAtPrice !== data.price ? ' <s>' + data.comparedAtPrice + '</s>' : '')
        : basePrice;
    }
    if (btn && !btn.disabled) {
      btn.textContent = sub ? baseBtn.replace(/—.*$/, '— ' + short(data.price)) : baseBtn;
    }
  }

  slot.addEventListener('change', update);
  new MutationObserver(setup).observe(slot, { childList: true, subtree: true });
  setup();
})();

/* Klaviyo sign-up popup backup. Privacy browsers (Brave Shields, Firefox strict
   tracking protection, private windows) block parts of Klaviyo: the script that
   times the popup, and Klaviyo's API or its bot check, so a sign-up can't be saved.
   1. If Klaviyo's own timer never opens the popup, open it here with the same rules
      (new visitors only, not again for a few days after closing or signing up).
   2. If Klaviyo can't save a sign-up, send the email through Shopify's newsletter
      form instead. Klaviyo's Shopify integration picks it up from there. */
(function () {
  if (window.top !== window) return;
  var box = document.querySelector('[data-kl-backup]');
  if (!box) return;
  var formId = box.getAttribute('data-form-id');
  var delay = (parseFloat(box.getAttribute('data-delay')) || 5) * 1000;
  var days = parseFloat(box.getAttribute('data-days')) || 3;
  var KEY = 'ab-kl-popup';
  var opened = false;
  var saved = false;
  var pending = null;

  function state() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function remember(what) {
    var s = state();
    s[what] = Date.now();
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }
  function identified() {
    if (box.hasAttribute('data-customer')) return true;
    var m = document.cookie.match(/(?:^|; )__kla_id=([^;]+)/);
    if (!m) return false;
    try {
      var id = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(id.$exchange_id || id.$email || id.$phone_number);
    } catch (e) { return false; }
  }
  function eligible() {
    var s = state();
    if (s.submitted || identified()) return false;
    return !s.closed || Date.now() - s.closed > days * 864e5;
  }
  function klaviyoForm() {
    return document.querySelector('form[data-testid="klaviyo-form-' + formId + '"]');
  }

  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {};
    if (d.formId !== formId) return;
    if (d.type === 'open') opened = true;
    if (d.type === 'close') remember('closed');
    if (d.type === 'submit' || d.type === 'stepSubmit') { saved = true; remember('submitted'); }
  });

  setTimeout(function () {
    if (opened || klaviyoForm() || !eligible() || /\/challenge/.test(location.pathname)) return;
    try {
      if (sessionStorage.getItem(KEY)) return;
      sessionStorage.setItem(KEY, '1');
    } catch (e) {}
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }, delay + 3000);

  function toast(text) {
    var el = document.querySelector('[data-kl-toast]');
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 400);
    }, 6000);
  }

  // Klaviyo's bot check (DataDome) can cover the page with a full-screen puzzle.
  function challenge() {
    return document.querySelector('[id^="ddChallengeContainer"]');
  }

  function closeKlaviyo() {
    var c;
    while ((c = challenge())) c.remove();
    var btn = document.querySelector('[role="dialog"] .klaviyo-close-form');
    if (btn) btn.click();
  }

  var backupForm = document.getElementById('ab-kl-backup');
  var backupEmail = backupForm && backupForm.querySelector('[name="contact[email]"]');

  // Shopify's spam check (hCaptcha) attaches to a form on its first change event,
  // cancels submits until then, and once it has a token calls the form's own
  // submit(). Giving the form a submit() that posts in the background keeps the
  // visitor on the page. If Shopify wants a visible captcha, submit again normally
  // (each try needs a fresh token) so the visitor lands on Shopify's captcha page.
  var DONE = "You're on the list. Your 10% code is on its way to your inbox.";
  var fullPage = false;
  if (backupForm) {
    backupForm.submit = function () {
      if (fullPage) return HTMLFormElement.prototype.submit.call(backupForm);
      fetch(backupForm.action.split('#')[0], { method: 'POST', body: new FormData(backupForm), credentials: 'same-origin' })
        .then(function (r) {
          if (/customer_posted=true/.test(r.url)) {
            remember('submitted');
            closeKlaviyo();
            toast(DONE);
          } else if (/challenge/.test(r.url)) {
            fullPage = true;
            backupForm.requestSubmit();
          }
        });
    };
  }
  if (location.hash === '#ab-kl-backup' && /customer_posted=true/.test(location.search)) {
    remember('submitted');
    history.replaceState(null, '', location.pathname);
    setTimeout(function () { toast(DONE); }, 300);
  }
  function prime() {
    if (backupEmail) backupEmail.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function backup(email, waited) {
    if (!backupForm) return;
    waited = waited || 0;
    if (!backupForm.dataset.hcaptchaBound && waited < 5000) {
      prime();
      return setTimeout(function () { backup(email, waited + 250); }, 250);
    }
    backupEmail.value = email;
    backupForm.requestSubmit();
  }

  function attempt(input) {
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    saved = false;
    prime();
    clearTimeout(pending);
    var started = Date.now();
    (function check() {
      if (saved || !input.isConnected || !input.offsetParent) return;
      var form = input.closest('form');
      var failed = (form && /error occurred/i.test(form.textContent)) || challenge();
      if (failed || Date.now() - started > 6000) return backup(email);
      pending = setTimeout(check, 400);
    })();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button');
    var form = btn && btn.closest('form[data-testid="klaviyo-form-' + formId + '"]');
    var input = form && form.querySelector('input[name="email"]');
    if (input) attempt(input);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('input[name="email"]')) return;
    if (e.target.closest('form[data-testid="klaviyo-form-' + formId + '"]')) attempt(e.target);
  }, true);
})();
